module.exports = __webpack_public_path__ + "media/assets/images/tour/1b_Tour_5-6de596c3b41b3e66c5483042bec44131.png";